// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const IntegrationBuilderDemo: MarkdocTagRegistration = {
  tag: 'integration-builder-demo',
  component: 'IntegrationBuilderDemo',
  attributes: {
    type: {
      type: String,
      matches: ['checkout', 'payments', 'card'],
    },
  },
};
